import { CommerceApiContext, CommerceApiContextOptions } from '../../common/types';
import { SearchFilterExperienceApi } from '../../models/search-filter/search-filter.api';
import { FocSearchFilterExperienceApi } from './foc-to-search-filter';
import { OcbSearchFilterExperienceApi } from './ocb-to-search-filter';

export const searchFilterExperienceAdapterFactory = (options: CommerceApiContextOptions): SearchFilterExperienceApi => {
  switch (options.context) {
    case CommerceApiContext.FOC:
      return new FocSearchFilterExperienceApi(options.httpServices.searchFilter.foc);
    case CommerceApiContext.OCB:
      return new OcbSearchFilterExperienceApi(options.httpServices.searchFilter.ocb);
    default:
      throw new Error(`Unknown CommerceApiContext ${options.context}`);
  }
};
